import type { MembershipDetails } from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface ResetReturningMemberBody {
    partnerEmail: string;
    partnerStytchId: string;
}

const useResetReturningMember = requestBuilder.mutation<
    GeneralResponse,
    ResetReturningMemberBody,
    { userId: string }
>({
    endpoint: ({ userId }) =>
        `/api/admin/users/${userId}/reset-returning-member`,
    method: 'POST',
});

export const useResetReturningMemberAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);
    const { mutateAsync } = useResetReturningMember(
        refetchMembershipMutationOptions,
    );

    const resetReturningMemberAsync = async (userId: string) => {
        return await mutateAsync({
            urlParams: {
                userId,
            },
        });
    };

    return {
        resetReturningMemberAsync,
    };
};
